import React, { useState, useEffect, useMemo } from 'react';
import { API, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';

function SmartUploadPage({showToast,user}){
  var[files,setFiles]=useState([]);
  var[dragOver,setDO]=useState(false);
  var[results,setResults]=useState([]);
  var[uploading,setUploading]=useState(false);
  // 진행 상태 (스마트 업로드)
  var[fileStatus,setFileStatus]=useState([]); // [{status:'pending'|'processing'|'success'|'fail', reason?}]
  var[progressIdx,setProgressIdx]=useState(0); // 현재 처리 중 번호 (1-based)
  // 면장 매칭 모달
  var[clResults,setClResults]=useState(null);
  var[clChecked,setClChecked]=useState({});
  var[clApplying,setClApplying]=useState(false);
  // WebSocket 실시간 알림
  useEffect(function(){var s=getSocket();if(!s)return;var handler=function(data){if(showToast){var labels={malso:'말소증',myunjang:'수출면장',purchase_confirm:'구매확인서',tax_invoice:'세금계산서',registration:'등록증'};showToast((labels[data.docType]||data.docType)+' 업로드 완료','ok')}};s.on('doc:uploaded',handler);return function(){s.off('doc:uploaded',handler)}},[]);
  // 페이지 이탈 경고 (업로드 진행 중)
  useEffect(function(){
    if(!uploading)return;
    var handler=function(e){e.preventDefault();e.returnValue='업로드가 진행 중입니다. 페이지를 떠나시겠습니까?';return e.returnValue};
    window.addEventListener('beforeunload',handler);
    return function(){window.removeEventListener('beforeunload',handler)};
  },[uploading]);

  var hf=function(fl){var a=[];for(var i=0;i<fl.length;i++)a.push(fl[i]);setFiles(function(p){return p.concat(a)});};

  var up=function(){
    if(!files.length){showToast('파일을 먼저 선택하세요','err');return;}
    var snapshot=files.slice();
    setUploading(true);setResults([]);setClResults(null);
    setFileStatus(snapshot.map(function(){return{status:'pending'}}));
    setProgressIdx(0);
    var rs=[];
    var runOne=function(i){
      if(i>=snapshot.length){
        setUploading(false);setFiles([]);setProgressIdx(0);
        // 면장 멀티매칭 응답이 있는지 확인
        var clearanceResult=rs.find(function(r){return r.multiMatch&&r.vehicles&&r.vehicles.length>0});
        if(clearanceResult){
          setClResults(clearanceResult);
          var checks={};
          if(clearanceResult.vehicles){clearanceResult.vehicles.forEach(function(v,j){if(v.matched)checks[j]=true})}
          setClChecked(checks);
          var otherResults=rs.filter(function(r){return r!==clearanceResult});
          setResults(otherResults);
          var clLabel=clearanceResult.docType==='purchase_confirm'?'구매확인서':clearanceResult.docType==='tax_invoice'?'세금계산서':'면장';
          showToast(clLabel+' OCR 완료: '+(clearanceResult.totalVehicles||0)+'대 중 '+(clearanceResult.matchedCount||0)+'대 매칭');
        } else {
          setResults(rs);
          var matched=rs.filter(function(r){return r.matched}).length;
          showToast(matched+'/'+rs.length+' 건 차량 매칭 완료');
        }
        return;
      }
      var file=snapshot[i];
      setProgressIdx(i+1);
      setFileStatus(function(prev){var n=prev.slice();n[i]={status:'processing'};return n});
      var fd=new FormData();fd.append('file',file);
      authFetch(API+'/smart-upload',{method:'POST',body:fd})
        .then(function(r){return r.json()})
        .then(function(d){
          var rec=Object.assign({file:file.name},d);
          rs.push(rec);
          setFileStatus(function(prev){
            var n=prev.slice();
            if(rec.matched)n[i]={status:'success'};
            else if(rec.success)n[i]={status:'success',reason:rec.skipReason||'미분류'};
            else n[i]={status:'fail',reason:rec.error||'실패'};
            return n;
          });
          runOne(i+1);
        })
        .catch(function(e){
          var rec={file:file.name,success:false,error:e.message};
          rs.push(rec);
          setFileStatus(function(prev){var n=prev.slice();n[i]={status:'fail',reason:e.message||'네트워크 오류'};return n});
          runOne(i+1);
        });
    };
    runOne(0);
  };
  // 진행/요약 카운트 (useMemo로 메모이제이션)
  var counts=useMemo(function(){
    var done=0,success=0,unmatched=0,fail=0;
    for(var i=0;i<fileStatus.length;i++){
      var s=fileStatus[i];
      if(s.status==='success'){done++;if(s.reason)unmatched++;else success++}
      else if(s.status==='fail'){done++;fail++}
    }
    var total=fileStatus.length;
    return{done:done,success:success,unmatched:unmatched,fail:fail,total:total,pct:total>0?Math.round(done/total*100):0};
  },[fileStatus]);
  var doneCount=counts.done,successCount=counts.success,unmatchedCount=counts.unmatched,failCount=counts.fail,totalCount=counts.total,pct=counts.pct;

  // 면장 매칭 모달 함수들
  var toggleCheck=function(idx){setClChecked(function(prev){var n=Object.assign({},prev);if(n[idx])delete n[idx];else n[idx]=true;return n})};
  var toggleAll=function(){
    if(!clResults||!clResults.vehicles)return;
    var allChecked=clResults.vehicles.every(function(v,i){return !v.matched||clChecked[i]});
    var n={};
    if(!allChecked){clResults.vehicles.forEach(function(v,i){if(v.matched)n[i]=true})}
    setClChecked(n);
  };
  var applyClearance=async function(){
    if(!clResults)return;
    var carIds=[];
    clResults.vehicles.forEach(function(v,i){
      if(clChecked[i]&&v.matched){
        var carId=v.car?v.car.id:v.carId;
        if(carId)carIds.push(carId);
      }
    });
    if(carIds.length===0){showToast('적용할 차량을 선택하세요','err');return;}
    setClApplying(true);
    try{
      // smart-upload 경유시 서버에서 이미 파일복사+상태변경 완료
      if(clResults.multiMatch){
        var applyLabel=clResults.docType==='purchase_confirm'?'선적대기':clResults.docType==='tax_invoice'?'세금계산서 저장':'면장완료';
        showToast('문서가 업로드되었습니다 ('+carIds.length+'대 '+applyLabel+' 처리)');
        setClResults(null);setClChecked({});
      }else{
        var resp=await authFetch(API+'/documents/clearance-apply',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({exportDecNo:clResults.exportDecNo||'',carIds:carIds,files:clResults.files||[]})});
        var d=await resp.json();
        if(d.success){showToast('면장 적용 완료: '+d.applied+'대 면장완료 처리');setClResults(null);setClChecked({})}
        else{showToast(d.error||'적용 실패','err')}
      }
    }catch(err){showToast('적용 실패: '+(err.message||''),'err')}
    setClApplying(false);
  };
  var checkedCount=Object.keys(clChecked).length;

  return(<div>
    <div className="card" style={{padding:20,marginBottom:20}}>
      <h3 style={{marginBottom:4}}>📁 스마트 문서 업로드</h3>
      <div style={{fontSize:12,color:'#64748b',marginBottom:16}}>말소증, 수출면장, 등록증 등을 업로드하면 AI가 자동 분류합니다.</div>
      <div className={'drop-zone '+(dragOver?'drag-over':'')} style={{padding:30,textAlign:'center',cursor:'pointer'}}
        onClick={function(){document.getElementById('smartFile').click()}}
        onDragOver={function(e){e.preventDefault();setDO(true)}}
        onDragLeave={function(){setDO(false)}}
        onDrop={function(e){e.preventDefault();setDO(false);hf(e.dataTransfer.files);}}>
        <div style={{fontSize:36,marginBottom:8}}>📂</div>
        <div style={{fontSize:14,fontWeight:600,color:'#475569'}}>클릭 또는 파일을 여기에 드래그</div>
        <div style={{fontSize:12,color:'#64748b',marginTop:4}}>말소증, 수출면장, 등록증 등을 업로드하면 AI가 자동 분류합니다</div>
        <div style={{fontSize:11,color:'#94a3b8',marginTop:4}}>여러 파일 동시 업로드 가능 · 이미지(jpg,png) 및 PDF 지원 · 파일당 최대 50MB</div>
        <input type="file" id="smartFile" accept="image/jpeg,image/png,application/pdf" multiple style={{display:'none'}} onChange={function(e){hf(e.target.files)}}/>
      </div>

      {files.length>0&&<div style={{marginTop:12}}>
        <div style={{fontSize:12,fontWeight:600,color:'#475569',marginBottom:6}}>선택된 파일 {files.length}개</div>
        {files.map(function(f,i){
          var st=fileStatus[i];
          var icon='⏳',color='#94a3b8',label='대기';
          if(st&&st.status==='processing'){icon='🔄';color='#2563eb';label='처리중'}
          else if(st&&st.status==='success'&&!st.reason){icon='✅';color='#16a34a';label='성공'}
          else if(st&&st.status==='success'&&st.reason){icon='⚠️';color='#d97706';label='미분류'}
          else if(st&&st.status==='fail'){icon='❌';color='#dc2626';label='실패'}
          return(
            <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'6px 10px',background:'#f8fafc',borderRadius:8,marginBottom:4,fontSize:12}}>
              <span style={{display:'flex',alignItems:'center',gap:8,flex:1,minWidth:0}}>
                <span style={{fontSize:14}}>{icon}</span>
                <span style={{whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{f.name}</span>
                {st&&<span style={{fontSize:10,fontWeight:700,color:color,marginLeft:6,whiteSpace:'nowrap'}}>{label}{st.reason?' — '+st.reason:''}</span>}
              </span>
              {!uploading&&<span style={{cursor:'pointer',color:'#ef4444',fontWeight:700,marginLeft:8}} onClick={function(){setFiles(files.filter(function(_,j){return j!==i}))}}>×</span>}
            </div>
          );
        })}
        {uploading&&totalCount>0&&<div style={{marginTop:10,padding:'10px 12px',background:'#eff6ff',border:'1px solid #bfdbfe',borderRadius:10}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:6,fontSize:12,fontWeight:700,color:'#1e3a8a'}}>
            <span>{progressIdx}/{totalCount} 처리 중...</span>
            <span>{pct}%</span>
          </div>
          <div style={{height:6,background:'#dbeafe',borderRadius:3,overflow:'hidden'}}>
            <div style={{height:'100%',width:pct+'%',background:'#2563eb',borderRadius:3,transition:'width .3s'}}></div>
          </div>
        </div>}
        <button onClick={up} disabled={uploading} style={{width:'100%',marginTop:10,padding:'12px',background:uploading?'#94a3b8':'#2563eb',color:'#fff',border:'none',borderRadius:10,fontSize:14,fontWeight:700,cursor:uploading?'default':'pointer'}}>
          {uploading?'AI 분석 중... ('+progressIdx+'/'+totalCount+')':'AI 자동 분류 업로드'}
        </button>
      </div>}
      {!uploading&&totalCount>0&&doneCount===totalCount&&<div style={{marginTop:12,padding:'12px 14px',background:'#f0fdf4',border:'1px solid #86efac',borderRadius:10}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:6}}>
          <div style={{fontSize:13,fontWeight:700,color:'#166534'}}>📊 처리 완료 — 총 {totalCount}건</div>
          <button className="btn btn-outline btn-sm" onClick={function(){setFileStatus([]);setResults([])}}>확인</button>
        </div>
        <div style={{display:'flex',gap:14,fontSize:12,fontWeight:600}}>
          <span style={{color:'#16a34a'}}>✅ 매칭 {successCount}건</span>
          <span style={{color:'#d97706'}}>⚠️ 미분류 {unmatchedCount}건</span>
          <span style={{color:'#dc2626'}}>❌ 실패 {failCount}건</span>
        </div>
      </div>}
    </div>

    {/* ═══ 면장 매칭 결과 모달 ═══ */}
    {clResults&&clResults.vehicles&&(function(){
      var matchedList=clResults.vehicles.filter(function(v){return v.matched});
      var unmatchedList=clResults.vehicles.filter(function(v){return !v.matched});
      return(<div className="card" style={{padding:16,marginBottom:20,border:'2px solid #3b82f6'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
          <h3 style={{margin:0,fontSize:16}}>{clResults.docType==='purchase_confirm'?'📋 구매확인서 매칭 결과':clResults.docType==='tax_invoice'?'📋 세금계산서 매칭 결과':'📋 수출면장 매칭 결과'} <span style={{color:unmatchedList.length>0?'#d97706':'#16a34a',fontSize:14}}>({matchedList.length}/{clResults.vehicles.length}대 성공)</span></h3>
          <div style={{display:'flex',gap:8,alignItems:'center'}}>
            <button className="btn btn-blue" onClick={applyClearance} disabled={clApplying||checkedCount===0}>{clApplying?'적용 중...':'선택 적용 ('+checkedCount+'대)'}</button>
            <button className="btn btn-outline btn-sm" onClick={function(){setClResults(null)}}>닫기</button>
          </div>
        </div>
        {clResults.exportDecNo&&clResults.docType!=='purchase_confirm'&&<div style={{background:'#eff6ff',padding:'10px 16px',borderRadius:8,marginBottom:14,fontSize:13,display:'flex',alignItems:'center',gap:12}}>
          <span style={{fontWeight:700,color:'#1e3a5f'}}>수출신고번호</span>
          <span style={{fontFamily:'monospace',fontWeight:700,fontSize:15,color:'#1e3a5f',letterSpacing:0.5}}>{clResults.exportDecNo}</span>
        </div>}
        {matchedList.length>0&&<div style={{marginBottom:unmatchedList.length>0?12:0}}>
          {matchedList.map(function(v){
            var idx=clResults.vehicles.indexOf(v);
            return(<div key={idx} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',background:'#f0fdf4',border:'1px solid #bbf7d0',borderRadius:8,marginBottom:6}}>
              <input type="checkbox" checked={!!clChecked[idx]} onChange={function(){toggleCheck(idx)}} style={{accentColor:'#16a34a'}}/>
              <span style={{fontSize:16}}>✅</span>
              <span style={{fontWeight:700,fontSize:13,color:'#166534'}}>{v.car?v.car.carNo:v.carNo||''}</span>
              <span style={{fontSize:12,color:'#166534'}}>({v.car?v.car.carType||'':v.model||''})</span>
              <span style={{fontSize:11,color:'#6b7280'}}>-</span>
              <span style={{fontFamily:'monospace',fontSize:11,color:'#166534'}}>{v.vin}</span>
              {(v.car&&v.car.status)&&<span style={{marginLeft:'auto',padding:'2px 8px',borderRadius:4,fontSize:10,fontWeight:600,background:'#dcfce7',color:'#166534'}}>{v.car.status}</span>}
            </div>);
          })}
        </div>}
        {unmatchedList.length>0&&<div>
          {unmatchedList.map(function(v){
            var idx=clResults.vehicles.indexOf(v);
            return(<div key={idx} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',background:'#fef2f2',border:'1px solid #fca5a5',borderRadius:8,marginBottom:6}}>
              <span style={{width:18,textAlign:'center',color:'#d1d5db'}}>-</span>
              <span style={{fontSize:16}}>❌</span>
              <span style={{fontFamily:'monospace',fontSize:12,fontWeight:700,color:'#dc2626'}}>{v.vin}</span>
              {v.model&&<span style={{fontSize:12,color:'#dc2626'}}>({v.model})</span>}
              {v.carNo&&<span style={{fontSize:12,color:'#d97706',fontWeight:600,marginLeft:4}}>{v.carNo}</span>}
              <span style={{fontSize:12,color:'#dc2626',marginLeft:4}}>- {v.skipReason||'미등록 차량'}</span>
            </div>);
          })}
        </div>}
        {matchedList.length>1&&<div style={{marginTop:8,display:'flex',gap:8,alignItems:'center'}}>
          <label style={{fontSize:12,color:'#64748b',cursor:'pointer',display:'flex',alignItems:'center',gap:4}}>
            <input type="checkbox" checked={matchedList.every(function(v){var idx=clResults.vehicles.indexOf(v);return clChecked[idx]})} onChange={toggleAll}/>
            매칭 차량 전체선택
          </label>
          <span style={{fontSize:11,color:'#94a3b8'}}>{checkedCount}대 선택됨</span>
        </div>}
      </div>);
    })()}

    {/* ═══ 일반 업로드 결과 ═══ */}
    {results.length>0&&<div className="card" style={{padding:20}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
        <h3 style={{margin:0}}>업로드 결과</h3>
        <button className="btn btn-outline btn-sm" onClick={function(){setResults([])}}>닫기</button>
      </div>
      {results.map(function(r,i){return(
        <div key={i} style={{border:'1px solid '+(r.matched?'#86efac':r.success?'#fde68a':'#fca5a5'),borderRadius:12,padding:14,marginBottom:10,background:r.matched?'#f0fdf4':r.success?'#fffbeb':'#fef2f2'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:6}}>
            <span style={{fontWeight:700,fontSize:13}}>{r.file}</span>
            {r.matched&&<span style={{background:'#16a34a',color:'#fff',padding:'2px 10px',borderRadius:10,fontSize:11,fontWeight:700}}>매칭 성공</span>}
            {!r.matched&&r.success&&<span style={{background:'#d97706',color:'#fff',padding:'2px 10px',borderRadius:10,fontSize:11,fontWeight:700}}>미분류</span>}
            {!r.success&&<span style={{background:'#dc2626',color:'#fff',padding:'2px 10px',borderRadius:10,fontSize:11,fontWeight:700}}>실패</span>}
          </div>

          {r.matched&&r.car&&<div>
            <div style={{fontSize:12,color:'#166534'}}>
              <b>{r.docName||r.docType}</b> → <b>{r.car.carNo}</b> {r.car.owner?' ('+r.car.owner+')':''} · {r.matchedBy} 일치
            </div>
            {r.folderPath&&<div style={{fontSize:11,color:'#4ade80',marginTop:3}}>저장위치: {r.folderPath}</div>}
            {r.newStatus&&<div style={{marginTop:6,background:'#dcfce7',border:'1px solid #86efac',borderRadius:6,padding:'4px 10px',fontSize:12,fontWeight:700,color:'#166534'}}>{r.newStatus} 단계 자동 진입</div>}
          </div>}

          {!r.matched&&r.success&&<div>
            {r.skipReason
              ?<div style={{fontSize:12,color:'#d97706'}}>{r.skipReason}{r.skippedCar?' — '+r.skippedCar.carNo:''}</div>
              :<div style={{fontSize:12,color:'#92400e'}}>문서를 인식했으나 매칭 차량을 찾지 못했습니다.</div>
            }
            {r.extracted&&<div style={{fontSize:11,color:'#92400e',marginTop:3}}>인식 정보 — 차량번호: <b>{r.extracted.carNo||'없음'}</b> / 차대번호: <b>{r.extracted.vin||'없음'}</b></div>}
            {r.folderPath&&<div style={{fontSize:11,color:'#d97706',marginTop:3}}>저장위치: {r.folderPath} (미분류)</div>}
          </div>}

          {!r.success&&<div style={{fontSize:12,color:'#dc2626'}}>{r.error||'문서 분석 중 오류가 발생했습니다.'}</div>}
        </div>
      );})}
    </div>}
  </div>);
}

export default SmartUploadPage;
